const trackingUtils = require('../utils/tracking.utils');
const trackFrontEventsUtils = require('od-modules/track_events/track.frontevents.utils');

module.exports = Odigeo.View.extend({
    selectors: {
        filterByHotelError: '.filter_hotel_name_error',
        filterByHotelClear: '.filter_hotel_name_clear',
        filterByHotelInputWrapper: '.filter_hotel_name_wrapper',
        accommodationSelectorInput: '.accommodationselector_input',
    },

    events: {
        'click .filter_hotel_name_button': 'onClickFilterNameButton',
        'tap .filter_hotel_name_clear': 'clearFilterClicked',
    },

    init() {
        this.opts = Odigeo.parseOptions(this.widget.options);
        this.$cachedSelectors.filterByHotelClear.addClass('odf-hidden');
        this.$el.on('updateFilterStatus.accommodationfilter', Odigeo._.bind(this.model.updateFilterStatus, this.model));
        this.$el.on('resetFilterStatus.accommodationfilter', Odigeo._.bind(this.cleanHotelNameFilter, this));
        this.listenTo(this.model, 'change:hotelName', this.resetValueAutocomplete);
    },

    onClickFilterNameButton(evt) {
        const hotelName = this.$el.find(this.selectors.accommodationSelectorInput)[0].value;
        if (hotelName.length) {
            trackingUtils.trackEvent('results_filters_hotels', 'search_hotel_name_introduced');
            trackFrontEventsUtils.trackClickEvent(evt);
        }
        this.sendToFather({hotelNameFilterModel: [{hotelName}]});
    },

    onElementClick() {
        if (!Odigeo._.isEmpty(this.getInputValue())) {
            Odigeo.trigger(`${this.widget.id}:getInputValue`);
            this.searchByHotelName();
            this.$cachedSelectors.filterByHotelClear.removeClass('odf-hidden');
        }
        this.toggleError();
    },

    searchByHotelName() {
        const hotelName = this.getInputValue();
        if (this.opts.hasToRedirect) {
            Odigeo.Session.set('hasToRedirectToHotelResults', !Odigeo._.isEmpty(hotelName));
        }
        this.sendToFather({
            hotelNameFilterModel: [{
                hotelName,
            }],
        });
    },

    toggleError() {
        if (this.opts.showError) {
            const hotelName = this.getInputValue();
            const showError = Odigeo._.isEmpty(hotelName);

            this.$cachedSelectors.filterByHotelError.toggleClass('odf-hidden', !showError);
            this.$cachedSelectors.filterByHotelInputWrapper.toggleClass('invalid', showError);

            if (showError) {
                trackingUtils.trackEvent('results_filters_hotels', 'search_hotel_name_introduced_error');
            }
        }
    },

    clearFilterClicked() {
        const hotelName = this.getInputValue();

        this.$cachedSelectors.filterByHotelClear.addClass('odf-hidden');
        trackingUtils.trackEvent('results_filters_hotels', 'search_hotel_name_remove_filter_click');

        if (!Odigeo._.isEmpty(hotelName)) {
            trackingUtils.trackEvent('results_filters_hotels', 'search_hotel_name_remove_filter');
            this.cleanHotelNameFilter();
        }
    },

    cleanHotelNameFilter() {
        this.$cachedSelectors.filterByHotelClear.addClass('odf-hidden');
        Odigeo.trigger(`${this.widget.id}:onResetFilter`);
        this.resetView(true);
        this.searchByHotelName();
    },

    resetValueAutocomplete() {
        const hotelName = this.model.get('hotelName');

        Odigeo.trigger(`${this.widget.id}:setInputValue`, hotelName);

        this.$cachedSelectors.filterByHotelClear.toggleClass('odf-hidden', !hotelName);
    },


    sendToFather(msg) {
        if (!Odigeo._.some(Odigeo._.get(msg, 'hotelNameFilterModel'), {hotelName: null})) {
            this.$el.trigger('filterHasChanged.accommodationfilter', msg);
        }
    },

    render() {
        this.resetView(this.model.get('isResetRequested'));
        return this;
    },

    resetView(isResetRequested) {
        if (isResetRequested) {
            this.resetInput();
        }
    },

    getInputValue() {
        return this.model.get('hotelName');
    },

    resetInput() {
        this.model.set('hotelName', '');
    },
});
